import styled from '@emotion/styled';
import _ from 'lodash';
import { createElement, FC, useEffect } from 'react';

import { useGetOfferQuery } from '../../../hooks/useGetOfferQuery';
import { useGetProjectQuery } from '../../../hooks/useGetProjectQuery';
import Spinner from '../../component/compound/Spinner';
import { SPACING_UNIT } from '../../constant/spacing';
import CreationContent from './CreationContent';

interface Props {
  creationSetId: string;
  creativeFormatId: string;
  assignmentId: string;
  onCreated: (creationId: string) => void;
  language: string;
  prepareProject: (projectId: string) => Promise<void>;
  className?: string;
}

export const NewCreationPage: FC<Props> = ({
  creationSetId,
  creativeFormatId,
  assignmentId,
  onCreated,
  language,
  prepareProject,
  className,
}) => {
  const { project, briefFiles, assetFiles, loading } = useGetProjectQuery(creationSetId);
  const { offer, loading: loadingOffer } = useGetOfferQuery(project?.creationSet?.offerId || undefined);

  useEffect(() => {
    if (project != null) {
      prepareProject(project.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project?.id]);

  if (!project || !offer) {
    return (
      <Root className={className}>
        <Spinner />
      </Root>
    );
  }
  const creationSet = project.creationSet!;
  const creativeFormat = creationSet.creativeFormats.find((cf) => cf.id == creativeFormatId);
  if (!creativeFormat) {
    throw new Error();
  }

  return (
    <CreationContent
      project={project}
      assignmentId={assignmentId}
      creativeFormat={creativeFormat}
      loading={loading || loadingOffer}
      assetFiles={assetFiles}
      briefFiles={briefFiles}
      targetCreationSet={creationSet}
      offer={offer}
      onCreated={onCreated}
      language={language}
    />
  );
};

const Root = styled('div')({
  margin: `0 ${SPACING_UNIT}px`,
  padding: `${SPACING_UNIT * 5}px calc((100% - 960px) / 2) ${SPACING_UNIT * 10}px`,
});
